export const useCode = () => {
  function getCode(id: string): Promise<Code> {
    // data-storeからの呼び出しのために他と形を揃えて残している
    return new Promise((resolve, reject) => {
      resolve(undefined)
    })
  }
  return {
    getCode,
  }
}
